import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {Typography} from "@mui/material";
import Chip from "@mui/material/Chip";
import PropTypes from "prop-types";
import {useNavigate} from "react-router";
import {cardNameNormalizer} from "../utils/normalizer";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default function MtgPrints({prints}) {
    const navigate = useNavigate()
    const [value, setValue] = React.useState('en');

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const langs = [...new Set(prints.map(p => p.lang))].sort();

    return (
        <>
            <Box>
                <Tabs
                    defaultValue={'en'}
                    value={value}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="prints"
                >{langs.map(l => <Tab label={l} value={l}/>)}
                </Tabs>
            </Box>
            <TabPanel value={value} index={value}>
                <Typography marginBottom={1}>All prints</Typography>
                {prints.filter(p => p.lang == value).map(p => (
                    <Chip onClick={() => navigate(`/${p.set}/${p.collector_number}/${cardNameNormalizer(p.name)}?l=${p.lang}`)}
                          sx={{
                              width: "100%", margin: 0.2, '& .MuiChip-label': {
                                  textAlign: "left", width: "100%"
                              }
                          }}
                          variant="outlined"
                          label={`${p.set_name} (${p.set} / ${p.lang})`}
                    />
                ))}
            </TabPanel>
        </>
    )

}
